import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { splitReducer, initSplitSdk } from '@splitsoftware/splitio-redux'
import defaultSlice from './slices/config/config'
import catalogSlice from './slices/catalog/catalog'
import cartSlice from './slices/cart/cart'
import summarySlice from './slices/summary/summary'
import ordersSlice from './slices/orders/orders'
import checkoutSlice from './slices/checkout/checkout'
import filtersSlice from './slices/filters/filters'
import bannersSlice from './slices/banners/banners'
import suggestedProductsSlice from './slices/suggestedProducts/suggestedProducts'
import globalPromotionsSlice from './slices/globalPromotions/globalPromotions'
import categoriesNavSlice from './slices/categoriesnav/categoriesnav'
import buyAgainSlice from './slices/recommendations/buyAgain'
import previouslyPurchasedSlice from './slices/recommendations/previouslyPurchased'
import recommendedForYouSlice from './slices/recommendations/recommendedForYou'
import alternativeProductsSlice from './slices/recommendations/alternativeProducts'

const sdkBrowserConfig = {
  core: {
    authorizationKey: process.env.REACT_APP_SPLIT_IO_API_KEY,
    key: 'key',
  },
}

const rootReducer = combineReducers({
  defaultSlice,
  catalogSlice,
  cartSlice,
  summarySlice,
  ordersSlice,
  checkoutSlice,
  filtersSlice,
  bannersSlice,
  suggestedProductsSlice,
  splitReducer,
  globalPromotionsSlice,
  categoriesNavSlice,
  buyAgainSlice,
  previouslyPurchasedSlice,
  recommendedForYouSlice,
  alternativeProductsSlice,
})

const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  })
}

store.dispatch(initSplitSdk({ config: sdkBrowserConfig }))

export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
export default store
